import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const ProcessViewModule = new Module({
  id: 'PROCESS:VIEW:RESULT-TABLE',
  name: 'Process',
  label: 'Process',
  path: 'process',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Process/View'))
  ),
  actions: {
    edit: {
      id: 'PROCESS:VIEW:*',
      name: 'VIEW',
      label: 'View'
    },
    delete: {
      id: 'process-delete',
      name: 'delete',
      label: 'Delete'
    },
    process: {
      id: 'PROCESS-PROCESS:VIEW:*',
      name: 'Process',
      label: 'Process'
    }
  }
});

export const ProcessAddModule = new Module({
  id: 'PROCESS:ADD:*',
  name: 'processAdd',
  path: 'process/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Process/Form'))
  ),
  actions: {
    add: {
      id: 'PROCESS:ADD:*',
      name: 'PROCESS Add',
      label: 'Add PROCESS'
    }
  }
});

export const ProcessEditModule = new Module({
  id: 'PROCESS:VIEW:DETAILS',
  name: 'PROCESS Edit',
  path: 'process/details/:processId',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Process/Form'))
  )
});

// export const ItemProcessViewModule = new Module({
//   id: 'ITEM-PROCESS:VIEW:*',
//   name: 'Item Process View',
//   path: 'item/process',
//   pathDef: 'item/process/:id',
//   Component: ComponentLoader(
//     lazy(() => import('src/content/management/Items/ProcessView'))
//   )
// });

const ProcessModules = [
  ProcessViewModule,
  ProcessAddModule,
  ProcessEditModule,
  // ItemProcessViewModule
];

export default new ModuleBundle('Process', ProcessModules);
